import ContingentSearchBenefit from "@/components/Shared/ContingentSearchBenefit";
import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ReadyToApply from "@/components/Shared/ReadyToApply";
import Solution from "@/components/Shared/Solution";
import SubmitForm from "@/components/Shared/SubmitForm";
import ServicePageBanner from "@/components/ServicePage/ServicePageBanner";
import ServicePageSwiper from "@/components/ServicePage/ServicePageSwiper";
import SEO from "@/components/SEO";
import vector from "@/assets/service/vector-service.png";
import localizePath from "@/functions/localizePath";

export default function ContingentSearchPage({ locale = "en" }) {
  return (
    <main className="bg-white h-full">
      <SEO
        path={localizePath("/contingent-search", locale)}
        title="Contingent Search | Lawrence Harvey"
        description="Our most comprehensive search solution."
      />
      <ServicePageBanner path="contingent-search" title="Contingent Search" />
      {/* <div className="container pt-10">
        <h2 className="text-4xl sm:text-[40px] font-normal  text-purple leading-[50px]">
          <CustomSourceFlowText
            title="We're dedicated to helping you shape the future. Prioritising agility and adaptability, our contingent search services ensure that clients only invest in successful placements, aligning our achievements with theirs."
            path="dynamic1.contingent-search.headline"
            locale={locale}
          />
        </h2>
      </div> */}
      <ContingentSearchBenefit
        title="What are the benefits of Contingent Search?"
        path="contingent-search"
      />
      <div className="container -mt-10 sm:-mt-20 pb-[128px]">
        <ReadyToApply
          bgColor="bg-blue"
          link="true"
          path="service"
          button1Link={localizePath("/vacancies", locale)}
        />
      </div>
      <div className="bg-purple">
        <ServicePageSwiper />
        <div className="relative">
          <img
            src={vector ?? ""}
            alt="vector"
            className="absolute right-0 bottom-20"
          />
          <Solution
            solution="contingent"
            color="text-white"
            path="contingent-search"
          />
          <div>
            <SubmitForm />
          </div>
        </div>
      </div>
    </main>
  );
}
